import {
  BarChart2,
  BrainCircuit,
  Code2,
  Eye,
  FileText,
  Globe,
  Image as ImageIcon,
  MessageSquare,
  Mic,
  PiggyBank,
  Video,
  Wrench,
  Zap,
} from 'lucide-react'

export const CAPABILITY_META: Record<string, { label: string; icon: React.ComponentType<{ className?: string }> }> = {
  chat:         { label: 'Chat',         icon: MessageSquare },
  reasoning:    { label: 'Reasoning',    icon: BrainCircuit },
  coding:       { label: 'Coding',       icon: Code2 },
  vision:       { label: 'Vision',       icon: Eye },
  'image-gen':  { label: 'Image Gen',    icon: ImageIcon },
  video:        { label: 'Video',        icon: Video },
  audio:        { label: 'Audio',        icon: Mic },
  search:       { label: 'Search',       icon: Globe },
  tool_use:     { label: 'Tool Use',     icon: Wrench },
  analysis:     { label: 'Analysis',     icon: BarChart2 },
  long_context: { label: 'Long Context', icon: FileText },
  fast:         { label: 'Fast',         icon: Zap },
  cheap:        { label: 'Cheap',        icon: PiggyBank },
}
